import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const DASHBOARD_ADMIN_EMAIL = 'ayrineluxe@gmail.com';
const DASHBOARD_SESSION_KEY = 'ayrine_dashboard_session';

/**
 * Protects dashboard routes. Only allows access when the user has logged in via the
 * Dashboard login form (email + password). Google login on the main site does NOT
 * grant dashboard access.
 */
export default function DashboardProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900" />
      </div>
    );
  }

  const hasDashboardSession = typeof sessionStorage !== 'undefined' && sessionStorage.getItem(DASHBOARD_SESSION_KEY);
  const isDashboardAdmin = user && !user.is_anonymous && user.email === DASHBOARD_ADMIN_EMAIL && hasDashboardSession;

  if (!isDashboardAdmin) {
    return <Navigate to="/dashboard/login" state={{ from: location }} replace />;
  }

  return children;
}
